<script>
import { mapActions } from 'vuex'
import { list, layoutNovo, get, del } from '@/api/acessogrupo'

// Colunas
import columns from './colunas'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  async mounted () {
    this.modalAdd = await this.newModal({
      component: 'app-acessogrupo-edit',
      width: 1024,
      onSave: async (data) => {
        if (data.descricao) this.refresh(data.descricao)
        else this.$refs.completeGrid.refreshList()
      },
      onCancel: () => {
        this.$refs.completeGrid.focoPesquisa()
      }
    })
  },
  data () {
    return {
      acoes: {
        add: 'acesso_grupo_incluir',
        edit: 'acesso_grupo_editar',
        delete: 'acesso_grupo_excluir'
      },
      modalAdd: false,
      columns: columns,
      indices: [
        { value: 'descricao', label: 'Descrição' }
      ]
    }
  },
  methods: {
    ...mapActions({
      newModal: 'modal/new',
      openModal: 'modal/open',
      confirmarModal: 'modal/confirmar',
      toaster: 'modal/toaster'
    }),
    refresh (data) {
      if (this.mode === 'tab') this.$refs.completeGrid.refreshList()
      else if (this.mode === 'modal') this.$refs.completeGrid.changeBusca(data)
    },
    async getList (filtros) {
      let data = await list(filtros)
      return {
        data: data.data,
        totalCount: data.total
      }
    },
    async novo () {
      let data = await layoutNovo()
      if (this.mode === 'modal') this.openModal({ modal: this.modalAdd, data })
      else this.$emit('onEdit', data)
    },
    async editar (row) {
      let data = await get(row.data.id)
      if (this.mode === 'modal') this.openModal({ modal: this.modalAdd, data })
      else this.$emit('onEdit', data)
    },
    async excluir (row) {
      this.confirmarModal({
        msg: 'Deseja realmente excluir esse grupo?',
        onConfirm: async () => {
          await del(row.data.id)
          this.toaster({ message: 'Excluido com sucesso!', color: 'success' })
          this.$refs.completeGrid.refreshList()
        }
      })
    },
    async selecionar (selecionado) {
      if (selecionado.id) this.$emit('save', selecionado)
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Listar Acesso Grupo" @onClose="() => $emit('cancel')">
    <ui-complete-grid
      ref="completeGrid"
      :columns="columns"
      :indices="indices"
      :selection="mode === 'modal'"
      :datasource="getList"
      :acoes="acoes"
      @onSelect="selecionar"
      @onCancel="$emit('cancel')"
      @onAdd="novo"
      @onEdit="editar"
      @onDelete="excluir" />
  </ui-layout-modal>
</template>
